module.exports = __webpack_public_path__ + "img/desktop.7af6c82b.png";